import React from "react";
import NumberFormat from "react-number-format";

import { FormGroup, Label } from "reactstrap";

const FormNumber = ({ label, ...props }) => (
  <FormGroup>
    <Label>{label}</Label>
    <NumberFormat {...props} />
  </FormGroup>
);

export default FormNumber;
